import React from 'react';

import Layout   from '../components/common/layout';
import Footer   from '../components/common/Footer';
import Sidebar  from '../components/common/Sidebar';

import Introduction from '../components/introduction/Introduction';

const IndexPage = () =>
  <Layout>
    <div id="wrapper">
      <Introduction />
    </div>
  </Layout>

export default IndexPage;
